import { getInicioCotizacion } from '../../utils/getRubro';

/** Ruta pública de la landing de venta presencial. */
export const RUTA_VENDEDOR = '/auto/vendedor';

/**
 * true si la cotización empezó en la landing del vendedor. Se mira el
 * `landingUrl` que el cotizador guarda una sola vez al arrancar: el resto del
 * flujo navega por las rutas comunes (/auto/cotizacion/...), pero ese dato
 * queda fijo en la primera página. `endsWith` cubre un build servido bajo una
 * base (REACT_APP_BASENAME).
 */
export const esLandingDeVendedor = (landingUrl?: string): boolean => {
  if (!landingUrl) return false;
  try {
    return new URL(landingUrl).pathname.replace(/\/+$/, '').endsWith(RUTA_VENDEDOR);
  } catch {
    return false;
  }
};

/**
 * true en todo el recorrido del asesor: la pantalla del vendedor y, después, el
 * cotizador común si la cotización empezó en /auto/vendedor. Quien entra por el
 * cotizador público nunca pasa por esa ruta, así que para esa persona es false.
 */
export const esRecorridoDeVendedor = (pathname: string, landingUrl?: string): boolean =>
  pathname.replace(/\/+$/, '').endsWith(RUTA_VENDEDOR) || esLandingDeVendedor(landingUrl);

/**
 * Adónde llevan los botones que vuelven al inicio de la cotización (US 23866). El asesor vuelve a
 * /auto/vendedor, que retoma su cotización en curso (o, si ya se borró, como después de una emisión,
 * muestra la pantalla del vendedor): si pasara por el paso de patente público, la pestaña dejaría de ser
 * del asesor. El cliente va al primer paso de siempre.
 */
export const inicioCotizacion = (rubro: string, landingUrl?: string, compania?: string): string =>
  rubro === 'auto' && esLandingDeVendedor(landingUrl) ? RUTA_VENDEDOR : getInicioCotizacion(rubro, compania);

/** Con el flag apagado, /auto/vendedor se comporta como cualquier ruta desconocida. */
export const redirigirComoRutaDesconocida = (): void => {
  window.location.href = window.location.origin;
};
